import { takeLatest, call, put } from 'redux-saga/effects';
import {
    CHECK_JWT_REQUEST,
    LOGIN_REQUEST,
    LOGOUT_REQUEST
} from "../constants/authenticationActionTypes";
import {
    loginSuccess,
    loginFailure,
    logoutSuccess,
    logoutFailure,
    checkJWTSuccess,
    checkJWTFailure,
} from "../actions/authenticationActions";
import { bffCall } from "../utils/api";

const login = (data) => bffCall('/login', 'POST', data);
const logout = () => bffCall('/logout', 'GET');
const checkJWT = () => bffCall('/me', 'GET');

function* loginSaga(action) {
    try {
        const response = yield call(login, action.payload);

        if (response.error) {
            yield put(loginFailure(response));
            return;
        }

        const authToken = response.token || 'BFF_SESSION';

        localStorage.setItem('authToken', authToken);

        yield put(loginSuccess({
            authToken,
            user: response.user,
            msg: response.msg || 'LOGIN_SUCCESSFUL',
            authenticatorEnabled: response?.authenticatorEnabled || false,
            provisioningURI: response?.provisioningURI || ""
        }));
    } catch (e) {
        yield put(loginFailure({ error: e.message }));
    }
}

function* logoutSaga() {
    try {
        yield call(logout);

        localStorage.removeItem('authToken');
        localStorage.removeItem('selectedRole');

        yield put(logoutSuccess());
    } catch (e) {
        yield put(logoutFailure(e.message));
    }
}

function* checkJWTSaga() {
    try {
        const response = yield call(checkJWT);

        const authToken = response.token || 'BFF_SESSION';

        localStorage.setItem('authToken', authToken);

        yield put(checkJWTSuccess({
            authToken,
            user: response.user
        }));
    } catch (e) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('selectedRole');
        yield put(checkJWTFailure(e.message));
    }
}

export default function* watchAuthenticationSagas() {
    yield takeLatest(LOGIN_REQUEST, loginSaga);
    yield takeLatest(LOGOUT_REQUEST, logoutSaga);
    yield takeLatest(CHECK_JWT_REQUEST, checkJWTSaga);
}